import OTPVerificationForm from "../../components/common/OTPVerification";

const OTPVerification = () => {
    return(
        <OTPVerificationForm />
    )
}

export default OTPVerification;